import { render, staticRenderFns } from "./ProductClassCode.vue?vue&type=template&id=0369045d&scoped=true&"
import script from "./ProductClassCode.vue?vue&type=script&lang=js&"
export * from "./ProductClassCode.vue?vue&type=script&lang=js&"
import style0 from "./ProductClassCode.vue?vue&type=style&index=0&id=0369045d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369045d",
  null
  
)

export default component.exports